import { get } from "lodash";
import { PaymentMethodEnum } from "../../enum/payment-method.enum";

type TransactionType = "valuation" | "admin" | "conveyancing";

interface ProcessPaymentInterface {
  application_uuid: string;
  payment_mode: PaymentMethodEnum | undefined;
  transaction_types: TransactionType[];
}

export class ProcessPayment implements ProcessPaymentInterface{
  application_uuid: string;
  payment_mode: PaymentMethodEnum | undefined;
  transaction_types: TransactionType[];
  
  constructor(initial?: ProcessPaymentInterface){
    this.application_uuid = get(initial, 'application_uuid', "");
    this.payment_mode     = get(initial, 'payment_mode', undefined);
    this.transaction_types = get(initial, 'transaction_types', []);
  }

  setApplicationUUID(application_uuid:string = ""){
    this.application_uuid = application_uuid;
  }
  
  setPaymentMode(payment_mode:PaymentMethodEnum){
    this.payment_mode = payment_mode;
  }
  
  addTransactionType(transaction_type: TransactionType){
    this.transaction_types.push(transaction_type);
  }
  
  json(){
    return this;
  }


}

type OwnerType =  "CURRENT_OWNER" | "PROPOSED_OWNER"

type FeeType = "TRANSFER_CONVEYANCING" | "MORTGAGE_CONVEYANCING"

export class CancellationFeesDto {
  fee_cost: number
  owner_type: OwnerType
  fee_type: FeeType

  constructor(fee_cost: number, owner_type: OwnerType, fee_type: FeeType) {
    this.fee_cost = fee_cost
    this.owner_type = owner_type
    this.fee_type = fee_type
  }
}
